import { useContactChannelsContext as z } from './contact-channels19.js';
import { checkCallMeSpamProtection as n } from './contact-channels73.js';
import { useQuery as m$1 } from './contact-channels42.js';

const m=(t=true)=>{const{callMeConfig:e}=z();return m$1({queryKey:["c2c-spam"],queryFn:()=>n(e==null?void 0:e.allowVPNs),staleTime:1/0,gcTime:1/0,retry:false,refetchOnWindowFocus:false,refetchInterval:false,enabled:t})};

export { m as useCheckC2CSpam };
//# sourceMappingURL=contact-channels48.js.map
